import React, { Component } from "react";
import { NavLink, ListItem, Collapse } from "react-router-dom";
import Select from "react-select";
import TagManager from 'react-gtm-module';
import { Logo, Img, SearchBar, SearchBtn, WeatherIconAgent } from "../UI/UI";
import { isMobile, getUrl, asyncgetWeather } from "../../Utility/Utility";
import "./Menu.css";

const appCountrys = [
  { langCode: "de", subDomain: "de", countryName: "Deutsch" },
  { langCode: "nl", subDomain: "nl", countryName: "Dutch" },
  { langCode: "at", subDomain: "at", countryName: "Österreich" },
  { langCode: "pl", subDomain: "pl", countryName: "Polski" },
  { langCode: "ro", subDomain: "ro", countryName: "Română" },
  { langCode: "se", subDomain: "se", countryName: "Svenska" },
  { langCode: "ch", subDomain: "ch", countryName: "Schwyzerdütsch" },
  { langCode: "cz", subDomain: "cz", countryName: "Cseh" },
  { langCode: "dk", subDomain: "dk", countryName: "Danish" },
  { langCode: "hu", subDomain: "hu", countryName: "Magyar" },
  { langCode: "gb", subDomain: "uk", countryName: "English" },
  { langCode: "ru", subDomain: "ru", countryName: "Русский" },
  { langCode: "fr", subDomain: "fr", countryName: "Français" },
  { langCode: "es", subDomain: "es", countryName: "Español" },
  { langCode: "it", subDomain: "it", countryName: "Italiana" },
  { langCode: "eu", subDomain: "eu", countryName: "الإمارات العربية المتحدة" },
  {
    langCode: "eu-en",
    subDomain: "eu-en",
    countryName: "United Arab Emirates",
  },
];

const CurrentFlagIcon = (props) => {
  var lang = props.lang ? props.lang : "";
  var langName = props.langName ? props.langName : "";
  var hideArrow = props.hideArrow === true ? true : false;
  var arrowDown = props.arrowDown === false ? true : false;
  let arrow = null;

  if (hideArrow == false) {
    arrow = (
      <Img
        desktopImg={"/right-arrow-wb.png"}
        cssClass={`bottom-arrow ${
          arrowDown === true ? "ac-arrow-down" : "ac-arrow-up"
        }`}
      />
    );
  }
  if (isMobile()) {
    return (
      <div className="flat-icon-div">
        <div className={"flat-icon-wrapper flat-icon-" + lang}>
          <button onClick={props.setLangState}>
            <Img
              desktopImg={"/flags/4x3/" + lang + ".svg"}
              cssClass={"ac-flag"}
            />
            <div>
              <p>{langName}</p>
            </div>
            {arrow}
          </button>
        </div>
      </div>
    );
  } else {
    return (
      <div className={"flat-icon-wrapper flat-icon-" + lang}>
        <button onClick={props.setLangState}>
          <Img desktopImg={"/flags/4x3/" + lang + ".svg"} />
          <div>
            <p>{langName}</p>
          </div>
          {arrow}
        </button>
      </div>
    );
  }
};

class MenuHome extends Component {
  state = {
    isOpen: false,
    isLangOpen: false,
    isArrowDown: false,
    isHover: false,
    keyWord: "",
    isSearchBarOpen: false,
    isPopupOpen: "",
    telAvivWeather: 20,
    waterTemp: 20,
    jerusalemWeather: 20,
    deadSeaWeather: 15,
    selectValue: "telaviv",
    cssClassMenuHide: "",
    isHover: false,
    isOpenSubMenu: false,
  };

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
      const weather = response[0];

      this.setState({
        deadSeaWeather: weather.deadsea.temperature,
        jerusalemWeather: weather.jerusalem.temperature,
        telAvivWeather: weather.telaviv.temperature,
        waterTemp: weather.telaviv.water_temp,
      });
    });
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  handleScroll = (event) => {
    let y = window.scrollY,
      cssClassMenuHide = "",
      winWidth = window.innerWidth;

    if (winWidth > 1000) {
      if (y > 50) {
        // console.log("say");
        cssClassMenuHide = " ac-hide-weather-lang";
      } else {
        cssClassMenuHide = " ";
      }
    }
    this.setState({
      cssClassMenuHide: cssClassMenuHide,
    });
  };

  getSearchValue = (e) => {
    this.setState({
      keyWord: e.target.value,
    });
  };

  onkeyUp = (e) => {
    if (this.state.keyWord == "") {
    } else {
      if (e.key === "Enter") {
        window.location.href =
          getUrl() + "Pages/SearchPage/?q=" + e.target.value;
      }
      // this.setState({ isPopupOpen:'ac-open' });
    }
  };
  onBlur = (e) => {
    if (isMobile()) {
      window.location.href = getUrl() + "Pages/SearchPage/?q=" + e.target.value;
    } else {
      null;
    }
  };

  showSearchResults = () => {
    if (this.state.keyWord == "") {
      alert("Please, type a search word.");
    } else {
      window.location.href =
        getUrl() + "Pages/SearchPage/?q=" + this.state.keyWord;
    }
  };

  showSearchBar = () => {
    if (this.state.isSearchBarOpen == false) {
      this.setState({ isSearchBarOpen: true });
    } else {
      this.setState({ isSearchBarOpen: false });
    }

    if (isMobile()) {
      this.setMenuState();
    }
  };

  setMenuState = () => {
    if (this.state.isLangOpen) {
      this.setState({
        isLangOpen: !this.state.isLangOpen,
        isOpen: !this.state.isOpen,
      });
    } else {
      this.setState({
        isOpen: !this.state.isOpen,
      });
    }
  };
  redirect = (subDomain) => {
    if (
      subDomain === "de" ||
      subDomain === "at" ||
      subDomain === "ch" ||
      subDomain === "en" ||
      subDomain === "pl" ||
      subDomain === "it" ||
      subDomain === "es" ||
      subDomain === "ru" ||
      subDomain === "fr" ||
      subDomain === "eu" ||
      subDomain === "eu-en"
    ) {
      window.location.href = "https://new.goisrael.com/" + subDomain;
    } else {
      window.location.href = "https://goisrael.com/?lang=" + subDomain;
      // window.location.href =  'https://localhost:3000/international/?lang=' + subDomain;
    }
  };

  setLangState = () => {
    if (isMobile()) {
      this.setState({
        isLangOpen: !this.state.isLangOpen,
        isArrowDown: !this.state.isArrowDown,
        // isOpen : !this.state.isOpen
      });
    } else {
      this.setState({
        isLangOpen: !this.state.isLangOpen,
        isArrowDown: !this.state.isArrowDown,
      });
    }
  };

  updateMenuActive = (id) => {
    var elems = document.querySelectorAll(".ac_menuitems");

    [].forEach.call(elems, function(el) {
      el.classList.remove("AC_active");
    });
    document.getElementById(id).classList.add("AC_active");
  };
  choseInterest = (e) => {
    TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'Interest', 'event_details':'-',}})
    const num = isMobile()
      ? 60
      : document.querySelector(".menu-outer-wrapper .container2").offsetHeight;
    e.preventDefault();
    window.scrollTo({
      top: document.querySelector("#chose-interest").offsetTop - num,
      left: 0,
      behavior: "smooth",
    });
    this.updateMenuActive(e.target.id);
    if (isMobile()) {
      this.setMenuState();
    }
    // this.updateMenuActive(e.target.id);
    // window.open("https://agents.israel.travel/#chose-interest", "_blank");
    // if (isMobile()) {
    //   this.setMenuState();
    // }
  };
  TravaelPlaning = (e) => {
    TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'Travael Planing', 'event_details':'-',}})

    // const num = isMobile()
    //   ? 60
    //   : document.querySelector(".menu-outer-wrapper .container2").offsetHeight;
    // e.preventDefault();
    // window.scrollTo({
    //   top: document.querySelector("#travel-planning").offsetTop - num,
    //   left: 0,
    //   behavior: "smooth",
    // });
    // this.updateMenuActive(e.target.id);
    e.preventDefault();
    window.open(
      "https://agents.israel.travel/Pages/InterestsGeneral#travel-planning",
      "_blank"
    );

    if (isMobile()) {
      this.setMenuState();
    }
  };
  BecomeAnExport = (e) => {
    TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'Become An Export', 'event_details':'-',}})

    // const num = isMobile()
    //   ? 60
    //   : document.querySelector(".menu-outer-wrapper .container2").offsetHeight;
    // e.preventDefault();
    // window.scrollTo({
    //   top: document.querySelector("#israel-expert").offsetTop - num,
    //   left: 0,
    //   behavior: "smooth",
    // });
    // this.updateMenuActive(e.target.id);
    e.preventDefault();
    window.open(
      "https://agents.israel.travel/Pages/InterestsGeneral#israel-expert",
      "_blank"
    );
    if (isMobile()) {
      this.setMenuState();
    }
  };

  ContactUs = (e) => {
    TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'Contact Us', 'event_details':'-',}})

    // const num = isMobile()
    //   ? 60
    //   : document.querySelector(".menu-outer-wrapper .container2").offsetHeight;
    // e.preventDefault();
    // window.scrollTo({
    //   top: document.querySelector("#form").offsetTop - num,
    //   left: 0,
    //   behavior: "smooth",
    // });
    // this.updateMenuActive(e.target.id);
    e.preventDefault();
    window.open("https://agents.israel.travel/Pages/ContactUs", "_blank");
    if (isMobile()) {
      this.setMenuState();
    }
  };
  InterestJewish = (e) => {
   
    e.preventDefault();
    TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'Interest', 'event_details':'Jewish',}})

    window.open("https://agents.israel.travel/Pages/InterestsJewish", "_blank");
  };
  faq = (e) => {
    e.preventDefault();
    TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'Faq', 'event_details':'-',}})

    window.open("https://agents.israel.travel/Pages/FAQ", "_blank");
  };
  InterestMice = (e) => {
    e.preventDefault();
    TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'Interest', 'event_details':'Mice',}})

    window.open("https://agents.israel.travel/Pages/InterestsMice", "_blank");
  };
  InterestGeneral = (e) => {
    e.preventDefault();
    TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'Interest', 'event_details':'General',}})

    window.open(
      "https://agents.israel.travel/Pages/InterestsGeneral",
      "_blank"
    );
  };
  InterestChristian = (e) => {
    e.preventDefault();
    TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'Interest', 'event_details':'Christian',}})

    window.open(
      "https://agents.israel.travel/Pages/InterestsChristian",
      "_blank"
    );
  };
  handleBoxToggle = () => {
    if (window.innerWidth > 1000) {
      this.setState({ isHover: !this.state.isHover });
    }
  };
  openMobSubMenu = () => {
    if (window.innerWidth < 1000) {
      this.setState({ isOpenSubMenu: !this.state.isOpenSubMenu });
    }
  };

  handleChange = (e) => {
    this.setState({ selectValue: e.target.value });
  };

  render() {
    const isLangOpen = this.state.isLangOpen;
    let cssClass = "inner";
    let cssHover = " ";
    let parentCssClass = "";
    let navOpen = "";

    if (this.state.isOpen === true) {
      cssClass += " open";
      navOpen += " open";
    }

    var countryContainer = null;
    var countryCssClass = "country-close";

    if (isLangOpen) {
      countryCssClass = "country-open";

      countryContainer = appCountrys.map((o) => {
        return (
          <CurrentFlagIcon
            lang={o.langCode}
            langName={o.countryName}
            setLangState={() => {
              this.redirect(o.subDomain);
            }}
            hideArrow={true}
          />
        );
      });
    }

    var langName = "UK";
    var langCode = "gb";
    var CurrentLang = localStorage.getItem("currentLang");

    if (CurrentLang != null) {
      langName = CurrentLang.toUpperCase();
      if (CurrentLang == "uk") {
        langCode = "gb";
        langName = "English";
      } else {
        langCode = CurrentLang;
      }
    }

    // alert(langName);

    return (
      <header className={`${this.state.cssClassMenuHide} `}>
        {(this.state.isLangOpen || this.state.isOpen) && (
          <div
            className={`nav-trigger-overlay`}
            onClick={this.setLangState}
          ></div>
        )}
        <div className="menu-outer-wrapper">
          <div
            className={` ${
              this.state.isOpenSubMenu ? " ac-opensubmenubg" : ""
            }`}
            onClick={this.openMobSubMenu}
          ></div>
          <div className={`container-flued ${this.state.isOpen}`}>
            <div className="container">
              <div className="col-50 ac-social-wrappper">
                {/*<a href="https://www.facebook.com/" aria-label="facebook" className="ac-facebook-link"><Img desktopImg="20210505/icons/facebook.svg" mobileImg="20210505/icons/facebook.svg" cssClass="ac-icon-twitter"/></a>
                    <a href="https://www.facebook.com/" aria-label="twitter" className="ac-twitter-link"><Img desktopImg="20210505/icons/twitter.svg" mobileImg="20210505/icons/twitter.svg" cssClass="ac-icon-twitter"/></a>
                    <a href="https://www.facebook.com/" aria-label="youtube" className=""ac-youtube-link><Img desktopImg="20210505/icons/youtube.svg" mobileImg="20210505/icons/youtube.svgg" cssClass="ac-icon-youtube"/></a>
                    <a href="https://www.facebook.com/" aria-label="flickr" className="ac-flickr-link"><Img desktopImg="20210505/icons/flickr.svg" mobileImg="20210505/icons/flickr.svg" cssClass="ac-icon-flickr"/></a>
                    <a href="https://www.facebook.com/" aria-label="instagram" className="ac-instagram-link"><Img desktopImg="20210505/icons/instagram.svg" mobileImg="20210505/icons/instagram.svg" cssClass="ac-icon-instagram"/></a>*/}

                {/* <a
                    href="https://www.facebook.com/goisrael"
                    aria-label="facebook"
                    className="ac-facebook-link ac-icon-twitter"
                  >
                    <span className="ac-screen-reader-only">facebook</span>
                  </a>
                  <a
                    href="https://twitter.com/israeltourism"
                    aria-label="twitter"
                    className="ac-twitter-link"
                  >
                    <span className="ac-screen-reader-only">twitter</span>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UClnfG0wryFSVWcmkQ_VCFTw"
                    aria-label="youtube"
                    className="ac-youtube-link"
                  >
                    <span className="ac-screen-reader-only">youtube</span>
                  </a>
                  <a
                    href="https://www.flickr.com/photos/israelphotogallery/sets/"
                    aria-label="flickr"
                    className="ac-flickr-link"
                  >
                    <span className="ac-screen-reader-only">flickr</span>
                  </a>
                  <a
                    href="https://www.instagram.com/visit_israel/"
                    aria-label="instagram"
                    className="ac-instagram-link"
                  >
                    <span className="ac-screen-reader-only">instagram</span>
                  </a> */}
              </div>
              <div className="col-50 ac-search-box-wrapper">
                {!isMobile() ? (
                  <SearchBtn
                    cssClass={"ac-search-btn"}
                    click={this.showSearchBar}
                  />
                ) : null}
                <div className="ac-show-weather">
                  {this.state.selectValue == "telaviv" ? (
                    <WeatherIconAgent
                      label={"TelAviv"}
                      temp={this.state.telAvivWeather}
                    />
                  ) : this.state.selectValue == "jerusalem" ? (
                    <WeatherIconAgent
                      label={"Jerusalem"}
                      temp={this.state.jerusalemWeather}
                    />
                  ) : this.state.selectValue == "deadsea" ? (
                    <WeatherIconAgent
                      label={"deadSeaWeather"}
                      temp={this.state.deadSeaWeather}
                    />
                  ) : (
                    <WeatherIconAgent
                      label={"TelAviv"}
                      temp={this.state.telAvivWeather}
                    />
                  )}
                </div>
                <select
                  className="ac-select-weather"
                  value={this.state.selectValue}
                  onChange={this.handleChange}
                >
                  <option value="telaviv">Tel Aviv</option>
                  <option value="jerusalem">Jerusalem</option>
                  <option value="deadsea">Dead Sea</option>
                </select>
                {!isMobile() ? (
                  <select className="ac-lang-choose">
                    <option value="telaviv">English</option>
                    <option value="jerusalem">Українська</option>
                    <option value="deadsea">Polski</option>
                    <option value="deadsea">Italiana</option>
                  </select>
                ) : null}
                {/*This is an old lang chouse*/}
                {/* {!isMobile() ? (
                    <CurrentFlagIcon
                      lang={langCode}
                      langName={langName}
                      setLangState={this.setLangState}
                      hideArrow={false}
                    />
                  ) : null} */}
              </div>
            </div>

            {this.state.isSearchBarOpen ? (
              <SearchBar
                cssClass={"ac-search-bar"}
                cssClasswrapper={"ac-wrapper-search-bar"}
                keyUp={this.onkeyUp}
                Change={this.getSearchValue}
                keyWord={this.state.keyWord}
                click={this.showSearchBar}
                cssClassPopupOpen={this.isPopupOpen}
                clickForResults={this.showSearchResults}
                blurOut={this.onBlur}
              />
            ) : null}
          </div>
          {isMobile() ? (
            <div className={"ac-box-shadow" + cssClass}></div>
          ) : null}
          <div className="container container2">
            <div className="col col-15 logo-outer-wrapper">
              <NavLink exact className="first" to="/">
                <span className="ac-screen-reader-only">logo</span>
                <Logo />
              </NavLink>
            </div>
            <div className="col col-85 menu-inner-wrapper">
              <div className={cssClass}>
                {isMobile() ? (
                  <SearchBar
                    cssClass={"ac-search-bar"}
                    cssClasswrapper={"ac-wrapper-search-bar"}
                    keyUp={this.onkeyUp}
                    Change={this.getSearchValue}
                    keyWord={this.state.keyWord}
                    click={this.showSearchBar}
                    cssClassPopupOpen={this.isPopupOpen}
                    clickForResults={this.showSearchResults}
                    blurOut={this.onBlur}
                  />
                ) : null}

                <NavLink exact className="first AC_active ac_menuitems" to="/">
                  Home
                </NavLink>
                <div className="ac-multinav">
                  <NavLink
                    id="menu-choose_i"
                    to=""
                    className="ac_menuitems menu-choose_interestdesk"
                    onClick={this.choseInterest}
                    onMouseOver={this.handleBoxToggle}
                    onMouseOut={this.handleBoxToggle}
                  >
                    INTERESTS
                    <span
                      className="ac-mob-show-submenu"
                      onClick={this.openMobSubMenu}
                    ></span>
                  </NavLink>
                  <div className="ac-intersetmob">
                    <NavLink
                      id="menu-choose_i"
                      to=""
                      className="ac_menuitems menu-choose_interestmob"
                      onClick={this.choseInterest}
                      onMouseOver={this.handleBoxToggle}
                      onMouseOut={this.handleBoxToggle}
                    >
                      INTERESTS
                    </NavLink>
                    <span
                      className="ac-mob-show-submenu"
                      onClick={this.openMobSubMenu}
                    ></span>
                  </div>
                  <div
                    className={`ac-sub-menu ${
                      this.state.isHover ? " show" : ""
                    } ${this.state.isOpenSubMenu ? " ac-open" : ""}`}
                    onMouseOver={this.handleBoxToggle}
                    onMouseOut={this.handleBoxToggle}
                  >
                    <NavLink
                      id="menu-choose_i"
                      to=""
                      className="ac_menuitems"
                      onClick={this.InterestGeneral}
                      onMouseOver={this.handleBoxToggle}
                      onMouseOut={this.handleBoxToggle}
                    >
                      GENERAL
                    </NavLink>
                    <NavLink
                      id="menu-choose_i"
                      to=""
                      className="ac_menuitems"
                      onClick={this.InterestChristian}
                    >
                      CHRISTIAN
                    </NavLink>
                    <NavLink
                      id="menu-choose_i"
                      to=""
                      className="ac_menuitems"
                      onClick={this.InterestJewish}
                    >
                      JEWISH
                    </NavLink>
                    <NavLink
                      id="menu-choose_i"
                      to=""
                      className="ac_menuitems"
                      onClick={this.InterestMice}
                    >
                      MICE
                    </NavLink>
                  </div>
                </div>

                <NavLink
                  id="menu-tourismB"
                  to=""
                  className="ac_menuitems"
                  onClick={this.BecomeAnExport}
                >
                  BECOME AN EXPERT
                </NavLink>
                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={this.TravaelPlaning}
                >
                  TRAVEL PLANNING
                </NavLink>

                <NavLink
                  id="menu-faqs"
                  to=""
                  className="ac_menuitems"
                  onClick={this.ContactUs}
                >
                  CONTACT US
                </NavLink>
                <NavLink
                  id="menu-faqs"
                  to=""
                  className="ac_menuitems"
                  onClick={this.faq}
                >
                  FAQ
                </NavLink>

                {isMobile() ? (
                  <div className="ac-arrow-langmob">
                    <div className="ac-innerarrow-langmob"></div>
                  </div>
                ) : null}
                {isMobile() ? (
                  // <CurrentFlagIcon
                  //   lang={langCode}
                  //   langName={langName}
                  //   setLangState={this.setLangState}
                  //   hideArrow={false}
                  //   arrowDown={this.state.isArrowDown}
                  // />

                  <select className="ac-lang-choose">
                    <option value="telaviv">English</option>
                    <option value="jerusalem">Українська</option>
                    <option value="deadsea">Polski</option>
                    <option value="deadsea">Italiana</option>
                  </select>
                ) : null}
                {/* {isMobile() ? (
                  <div className="ac-mobile-weather-wrapper">
                    <div className="ac-show-weather">
                      {this.state.selectValue == "telaviv" ? (
                        <WeatherIconAgent
                          label={"TelAviv"}
                          temp={this.state.telAvivWeather}
                        />
                      ) : this.state.selectValue == "jerusalem" ? (
                        <WeatherIconAgent
                          label={"Jerusalem"}
                          temp={this.state.jerusalemWeather}
                        />
                      ) : this.state.selectValue == "deadsea" ? (
                        <WeatherIconAgent
                          label={"deadSeaWeather"}
                          temp={this.state.deadSeaWeather}
                        />
                      ) : (
                        <WeatherIconAgent
                          label={"TelAviv"}
                          temp={this.state.telAvivWeather}
                        />
                      )}
                    </div>
                    <select
                      className="ac-select-weather"
                      value={this.state.selectValue}
                      onChange={this.handleChange}
                    >
                      <option value="telaviv">Tel Aviv</option>
                      <option value="jerusalem">Jerusalem</option>
                      <option value="deadsea">Dead Sea</option>
                    </select>
                  </div>
                ) : null} */}
                {/* {isMobile() ? (
                  <div
                    className={"container country-container " + countryCssClass}
                  >
                    <div className="country-container-inner">
                      <div className="country-container-title">
                        <h3>Choose your language:</h3>
                        <button
                          id="close-lang"
                          type="button"
                          onClick={this.setLangState}
                        >
                          <svg
                            aria-hidden="true"
                            focusable="true"
                            data-prefix="fas"
                            data-icon="times"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 352 512"
                            class="svg-inline--fa fa-times fa-w-11 fa-2x"
                          >
                            <path
                              fill="currentColor"
                              d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                              class=""
                            ></path>
                          </svg>
                        </button>
                      </div>
                      <div className="country-container-flags-wrapper">
                        {countryContainer}
                      </div>
                    </div>
                  </div>
                ) : null} */}

                {/* {isMobile() ? (
                  <div className="ac-social-mobile">
                    <a
                      href="https://www.facebook.com/goisrael"
                      aria-label="facebook"
                      className="ac-facebook-link ac-icon-twitter"
                    >
                      <span className="ac-screen-reader-only">facebook</span>
                    </a>
                    <a
                      href="https://twitter.com/israeltourism"
                      aria-label="twitter"
                      className="ac-twitter-link"
                    >
                      <span className="ac-screen-reader-only">twitter</span>
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UClnfG0wryFSVWcmkQ_VCFTw"
                      aria-label="youtube"
                      className="ac-youtube-link"
                    >
                      <span className="ac-screen-reader-only">youtube</span>
                    </a>
                    <a
                      href="https://www.flickr.com/photos/israelphotogallery/sets/"
                      aria-label="flickr"
                      className="ac-flickr-link"
                    >
                      <span className="ac-screen-reader-only">flickr</span>
                    </a>
                    <a
                      href="https://www.instagram.com/visit_israel/"
                      aria-label="instagram"
                      className="ac-instagram-link"
                    >
                      <span className="ac-screen-reader-only">instagram</span>
                    </a>
                  </div>
                ) : null} */}
              </div>
              <div className="show-on-mobile">
                {/*<button className="open-mobile-menu navbar-toggle" onClick={this.setMenuState} >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>*/}

                <button
                  className={`open-mobile-menu navbar-toggle ${navOpen}`}
                  onClick={this.setMenuState}
                  id="nav-icon1"
                  aria-label="navigator button"
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </button>
              </div>
            </div>
            <div className="clear"></div>
          </div>
        </div>

        {!isMobile() ? (
          <div className={"container country-container " + countryCssClass}>
            <div className="country-container-inner">
              <div className="country-container-title">
                <h3>Choose your language:</h3>
                <button
                  id="close-lang"
                  type="button"
                  onClick={this.setLangState}
                >
                  <svg
                    aria-hidden="true"
                    focusable="true"
                    data-prefix="fas"
                    data-icon="times"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 352 512"
                    className="svg-inline--fa fa-times fa-w-11 fa-2x"
                  >
                    <path
                      fill="currentColor"
                      d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                      className=""
                    ></path>
                  </svg>
                </button>
              </div>
              <div className="country-container-flags-wrapper">
                {countryContainer}
              </div>
            </div>
          </div>
        ) : null}
      </header>
    );
  }
}

export default MenuHome;



// WEBPACK FOOTER //
// ./src/Components/Menu/MenuHome.js